import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { RadioModel } from "../../../shared/model/radio.model";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { PersonalDataService } from "../../service/personal-data.service";

@Component({
  selector: "app-birth-state",
  templateUrl: "./birth-state.component.html",
  styleUrls: ["./birth-state.component.scss"],
})
export class BirthStateComponent
  extends DefaultPageComponent
  implements OnInit
{
  selectedItem = "";
  selectedName = "";
  birthState = new Array<RadioModel>();
  textSearch: string;
  fieldSearch = "value";
  headerId = "birth-state";
  titlePage = "Dados pessoais";
  buttonEnable = false;
  @ViewChild("content") content: ElementRef;
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    private personalDataService: PersonalDataService,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    public analycticsNativeService: AnalycticsNativeService,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.State);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainState();
    this.editFieldInvest("uf_nascimento_sigla", "uFOfBirth", "personalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "9";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.textSearch = "";
    this.birthState = this.orderList(this.birthState, this.selectedItem);
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.birthState;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathEstadoNascimento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathEstadoNascimento,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    if (
      this.selectedItem !==
      this.journeyService.registratioJourney.data.personalData?.uFOfBirth
    ) {
      this.personalDataService.birthStatePrevious = {
        uf: this.journeyService.registratioJourney.data.personalData?.uFOfBirth,
        ufName:
          this.journeyService.registratioJourney.data.personalData
            ?.uFOfBirthName,
      };
    }

    this.sendAnalyticsFirstView = true;
    this.personalDataService.setBirthStateName(this.selectedName);
    this.personalDataService.setBirthState(this.selectedItem);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.birthState,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getDomainState() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.birthState = this.orderList(
            dominios,
            this.journeyService.registratioJourney.data.personalData?.uFOfBirth
          );
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.loading = false;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.loading = false;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.personalData.uFOfBirth) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.personalData.uFOfBirth;
      this.selectedName =
        this.journeyService.registratioJourney.data.personalData.uFOfBirthName;
    }
  }

  backPage() {
    this.analyticsEventClique();
    if (this.personalDataService.changeBirthState) {
      this.personalDataService.setBirthStateName(
        this.personalDataService.birthStatePrevious.ufName
      );
      this.personalDataService.setBirthState(
        this.personalDataService.birthStatePrevious.uf
      );
      this.personalDataService.changeBirthState = false;
    }

    setTimeout(() => this.back(), 80);
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  changeValue() {
    this.birthState = this.orderList(this.birthState, this.selectedItem);
  }
}
